// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.month-picker {
  background-color: #ffffff;
  border-radius: 8px;
}
.month-picker__custom-input {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 96% center;
  width: 210px;
  height: 40px;
  padding-left: 10px;
  border: 1px solid #E9E9E9;
  border-radius: 8px;
  cursor: pointer;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.react-datepicker__aria-live {
  display: none;
}

.react-datepicker-popper {
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/common/month-input/month-input.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;AACJ;AACI;EACI,wEAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;;AAKA;EACI,aAAA;AAFJ;;AAIA;EACI,UAAA;AADJ","sourcesContent":[".month-picker {\n    background-color: #ffffff;\n    border-radius: 8px;\n\n    &__custom-input {\n        background: url(\"../../assets/icons/calendar.svg\") no-repeat 96% center;\n        width: 210px;\n        height: 40px;\n        padding-left: 10px;\n    \n        border: 1px solid #E9E9E9;\n        border-radius: 8px;\n        cursor: pointer;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n      }\n}\n\n.react-datepicker__aria-live {\n    display: none;\n}\n.react-datepicker-popper {\n    z-index: 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
